"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMSX Rest API
 * EMSX Rest API for Vet lookups
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageAPILocationPageToJSON = exports.PageAPILocationPageFromJSONTyped = exports.PageAPILocationPageFromJSON = exports.instanceOfPageAPILocationPage = void 0;
const runtime_1 = require("../runtime");
const APILocationPage_1 = require("./APILocationPage");
/**
 * Check if a given object implements the PageAPILocationPage interface.
 */
function instanceOfPageAPILocationPage(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}
exports.instanceOfPageAPILocationPage = instanceOfPageAPILocationPage;
function PageAPILocationPageFromJSON(json) {
    return PageAPILocationPageFromJSONTyped(json, false);
}
exports.PageAPILocationPageFromJSON = PageAPILocationPageFromJSON;
function PageAPILocationPageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': (json['items'].map(APILocationPage_1.APILocationPageFromJSON)),
        'total': json['total'],
        'page': !runtime_1.exists(json, 'page') ? undefined : json['page'],
        'size': !runtime_1.exists(json, 'size') ? undefined : json['size'],
        'pages': !runtime_1.exists(json, 'pages') ? undefined : json['pages'],
    };
}
exports.PageAPILocationPageFromJSONTyped = PageAPILocationPageFromJSONTyped;
function PageAPILocationPageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': (value.items.map(APILocationPage_1.APILocationPageToJSON)),
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}
exports.PageAPILocationPageToJSON = PageAPILocationPageToJSON;
